import React, {Component} from 'react';
import PropTypes from 'prop-types';
import serialize from 'form-serialize';
import Button from '@spothero/ui/button';
import Form from '@spothero/ui/form';
import FormGroup from '@spothero/ui/form-group';
import TextButton from '@spothero/ui/text-button';
import UserUtils from 'user/user-utils';
import EmailControl from 'common/email/EmailControl';
import isNil from 'lodash/isNil';

export default class GuestLogin extends Component {
    static propTypes = {
        focus: PropTypes.bool,
        onLoginToggle: PropTypes.func.isRequired,
        onUserChange: PropTypes.func.isRequired,
    };

    state = {
        hasSuggestion: false,
        shouldConfirm: false,
    };

    _onEmailControlChange = ({suggestion}) => {
        this.setState({hasSuggestion: !isNil(suggestion)});
    };

    _onSubmit = evt => {
        const {email} = serialize(evt.target, {hash: true});
        const {hasSuggestion, shouldConfirm} = this.state;

        if (hasSuggestion && !shouldConfirm) {
            this.setState({shouldConfirm: true});

            return;
        }

        this.props.onUserChange({
            user: {
                status: UserUtils.AUTH_STATE.GUEST,
                email,
            },
        });
    };

    render() {
        const {focus, onLoginToggle} = this.props;

        return (
            <Form
                id="GuestLogin-form"
                className="GuestLogin"
                onSubmit={this._onSubmit}
            >
                <FormGroup className="FormGroup-responsive">
                    <EmailControl
                        required
                        className="GuestLogin-email"
                        focus={focus}
                        helpNode="We'll send your reservation with clear instructions"
                        onChange={this._onEmailControlChange}
                    />
                </FormGroup>
                <div className="FormActions">
                    <Button
                        className="GuestLogin-submit"
                        color="primary"
                        type="submit"
                    >
                        {this.state.shouldConfirm
                            ? 'Confirm Email'
                            : 'Continue as Guest'}
                    </Button>
                    <TextButton onClick={onLoginToggle}>
                        Sign In or Create Account
                    </TextButton>
                </div>
            </Form>
        );
    }
}
